import React from 'react'
import cn from 'classnames'

import { TabModeEnum } from '../interface'
import { useTabsSelectSaleAnalytics } from '../TabsSelectSaleAnalytics'

interface TabProps {
  tabId: string
  children: React.ReactNode
  dataTest?: string
  disabled?: boolean
  isFirstTabMargin?: boolean
}

export function Tab({
  tabId,
  dataTest,
  disabled = false,
  children,
  isFirstTabMargin,
}: TabProps) {
  const { mode, activeTab, handleUpdateActiveTab } =
    useTabsSelectSaleAnalytics()
  return (
    <button
      data-test={dataTest}
      type='button'
      disabled={disabled}
      className={cn(
        'flex px-[20px] py-[9px] min-w-fit h-[40px] items-center justify-center cursor-pointer font-light',
        {
          'rounded-[8px] bg-secondary text-white':
            tabId === activeTab && mode === TabModeEnum.BOX,
          'rounded-[8px] bg-gray-4 text-secondary-1':
            tabId !== activeTab && mode === TabModeEnum.BOX,
          'border-b-[3px] border-secondary dark:border-dark-10 text-secondary dark:text-dark-10 font-bold z-[1]':
            tabId === activeTab && mode === TabModeEnum.LINE,
          'text-secondary-1': tabId !== activeTab && mode === TabModeEnum.LINE,
          'cursor-no-drop opacity-40': disabled,
          'first:ml-[20px]': isFirstTabMargin,
        }
      )}
      onClick={() => handleUpdateActiveTab(tabId)}
    >
      {children}
    </button>
  )
}
